import { lazy } from 'react';
import Fallback, { createUseI18n } from 'keycloakify/login';

import { kcContext } from 'config/kc-context';

const Template = lazy(() => import('keycloakify/login/Template'));

export default function KeycloakFallback() {
  const { useI18n } = createUseI18n({});
  const i18n = useI18n({ kcContext });

  if (i18n === null) {
    return null;
  }

  return <Fallback {...{ kcContext, i18n }} Template={Template} doUseDefaultCss={true} />;
}
